import { BasicTooltip, Icon, SimpleModal } from '@livable/saas-react-components';
import { Button } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import { observer } from 'mobx-react-lite';
import { BatchPostChargeModalContent } from './content';
import { useStore } from 'src/stores';
import { useTranslation } from 'react-i18next';
export const BatchPostChargeModal = observer(_ref => {
  var _store$homeDashboardS;
  let _ref$trigger = _ref.trigger,
    trigger = _ref$trigger === void 0 ? undefined : _ref$trigger;
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const defaultTrigger = /*#__PURE__*/React.createElement(BasicTooltip, {
    title: "Post charge or credit",
    placement: "top",
    hideOnMobile: true
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "actionIcon",
    size: "small",
    'custom-attribute': '478-batch-post-charge-modal'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "coin"
  })));
  return /*#__PURE__*/React.createElement(SimpleModal, {
    trigger: trigger || defaultTrigger,
    title: "Post charge or credit",
    subTitle: store.residenciesMultiActionStore.isSelectedIsMultiPropertyView ? store.residenciesMultiActionStore.isSelectedFromSingleProperty ? (_store$homeDashboardS = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS === void 0 || (_store$homeDashboardS = _store$homeDashboardS.propertyDetails(store.residenciesMultiActionStore.selectedDetails[0].propertyId).propertyInformation) === null || _store$homeDashboardS === void 0 || (_store$homeDashboardS = _store$homeDashboardS.address) === null || _store$homeDashboardS === void 0 ? void 0 : _store$homeDashboardS.addressString : t('general.residents_are_selected_from_number_of_properties', {
      numberOfProperties: store.residenciesMultiActionStore.selectedPropertyIds.length
    }) : null,
    noFooter: true
  }, /*#__PURE__*/React.createElement(BatchPostChargeModalContent, null));
});
BatchPostChargeModal.propTypes = {
  trigger: PropTypes.node
};